export default {"src":"/_next/static/image/public/images/ReferralGift.7ca3d9a8930206c9196a0b5bbc207a1c.svg","height":167,"width":224};